import { useMemo } from 'react';

import { getIdMap } from '../../helpers/helpers';
import useProjectOrGlobalCostcodes from '../../costcodes/useProjectOrGlobalCostcodes';
import useProjectCostcodesFetch from '../../costcodes/useProjectCostcodesFetch';

// description is used by cost code tables. Wage/billing columns are the
// costcode attribute options in attributeConfig.js.
export const ENTRY_COSTCODE_COLUMNS = [
  'description',
  'hourlyWage',
  'dailyWage',
  'wageAdjustment',
  'wageMultiplier',
  'hourlyBillingRate',
  'dailyBillingRate',
];

function useEntryCostcodes({ projectIds = [], divisionIds = [] }) {
  const {
    projectCostcodes,
    loading: projectCostcodesLoading,
    fetchProjectCostcodes,
  } = useProjectCostcodesFetch({
    projectIds,
    includeCategoryIds: true,
    columns: ENTRY_COSTCODE_COLUMNS,
  });

  const {
    costcodes: globalCostcodes,
    loading: globalCostcodesLoading,
  } = useProjectOrGlobalCostcodes({
    projectId: null,
    divisionIds,
    visible: true,
    includeCategoryIds: true,
    columns: ENTRY_COSTCODE_COLUMNS,
  });

  const allCostcodes = useMemo(() => [
    ...projectCostcodes,
    ...globalCostcodes,
  ], [projectCostcodes, globalCostcodes]);

  const costcodeMap = useMemo(() => getIdMap(allCostcodes), [allCostcodes]);

  return {
    costcodes: allCostcodes,
    costcodeMap,
    costcodesLoading: projectCostcodesLoading || globalCostcodesLoading,
    fetchProjectCostcodes,
  };
}

export default useEntryCostcodes;
